
import { defineComponent, onMounted, reactive, toRefs, computed, ref } from "vue";
import ApiLogistics from "@/request/apis/api_logistics";
import router from "@/router";
import { message, notification } from "ant-design-vue/es";
import StorageUtil from "@/utils/storage_util";
import {
    EditOutlined,
    CheckOutlined,
    CloseOutlined,
} from "@ant-design/icons-vue";
import ImageView from "@/components/ImageView.vue";
import DriverSet from "@/components/DriverSet.vue";
import PageUtil from "@/utils/page_util";
import { IDriverItem, IEditDriver } from "@/models/logistics_member";
import ApiSetting from "@/request/apis/api_setting";
import UploadUtil from "@/utils/upload_util";
import { baseUrl } from "@/utils/config";
import create from "@ant-design/icons-vue/lib/components/IconFont";

interface IState {
    list: any;
    total: number;
    loading: boolean;
    visible: boolean;
    detailData: any;
    searches: any
}

const genderREL = {
    0: "保密",
    1: "男",
    2: "女"
};

// 表格
const columns = [
    {
        title: "ID",
        dataIndex: "id",
        key: "id",
        align: "center"
    },
    {
        title: "姓名",
        dataIndex: "name",
        key: "name",
        align: "center"
    },
    {
        title: "性别",
        dataIndex: "gender",
        key: "gender",
        align: "center"
    },
    {
        title: "应聘职位",
        dataIndex: "position",
        key: "position",
        align: "center"
    },
    {
        title: "毕业院校",
        dataIndex: "graduate_school",
        key: "graduate_school",
        align: "center"
    },
    {
        title: "专业",
        dataIndex: "major",
        key: "major",
        align: "center"
    },
    {
        title: "期望薪资",
        dataIndex: "salary",
        key: "salary",
        align: "center"
    },
    {
        title: "面试时间",
        dataIndex: "create_time",
        key: "create_time",
        align: "center"
    },

    {
        title: "操作",
        dataIndex: "action",
        key: "action",
        align: "center"
    },
];

export default defineComponent({
    name: "DriverList",
    components: {
        EditOutlined,
        CheckOutlined,
        CloseOutlined,
        ImageView,
        DriverSet,
    },
    setup() {
        const state: IState = reactive({
            list: [],
            total: 0,
            loading: false,
            visible: false,
            detailData: '',
            searches: {
                page: 1,
                limit: 10,
                name: '',
                create_time: [],
            }
        });

        const pagination = computed(() => ({
            total: state.total,
            current: state.searches.page,
            pageSize: state.searches.limit,
            showTotal: (total: any) => `共${total}条数据`,
            defaultPageSize: 10,
            // pageSizeOptions: ['5', '10', '15', '20'], // 可不设置使用默认
            showSizeChanger: true, // 是否显示pageSize选择
            showQuickJumper: true, // 是否显示跳转窗
        }));

        // 列表当前页更改
        const handleTableChange = (pages: any) => {
            state.searches.limit = pages.pageSize;
            state.searches.page = pages.current;
            getList();
        };

        //获取列表
        const getList = async () => {
            let params = { ...state.searches };
            state.loading = true;
            const res = await ApiSetting.InterviewFormList(params);
            state.loading = false;
            if (res && res.error_code === 0) {
                const data: any = res.data
                state.total = data.total || 0;
                state.list = data.data || [];
            }
        };

        const onSearch = async() => {
            getList()
        };

        const onReset = async() => {
            state.searches = {
                page: 1,
                limit: 10,
                name: '',
                create_time: [],
            }
            getList()
        }

        const getDetail = async (val) => {
            // const params = {id:val.id}
            // const res = await ApiSetting.InterviewFormInfo(params);
            // if (res && res.error_code === 0) {
            //     state.visible = true
            //     state.detailData = res.data
            // }
            router.push({ path: '/resume/detail', query: { id: val.id } }).then()
        }
        const filterOption = (input: string, option: any) => {
            console.log(option, 123)
            return option.key.indexOf(input) >= 0;
        };




        // 删除
        const onDel = async (item) => {

        }

        const print = ref({
            id: 'printBox',//这里的id就是上面我们的打印区域id，实现指哪打哪
            popTitle: '配置页眉标题', // 打印配置页上方的标题
            extraHead: '', // 最上方的头部文字，附加在head标签上的额外标签，使用逗号分割
            previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
            zIndex: 20002, // 预览窗口的z-index，默认是20002，最好比默认值更高
            previewBeforeOpenCallback() { console.log('正在加载预览窗口！'); }, // 预览窗口打开之前的callback
            previewOpenCallback() { console.log('已经加载完预览窗口，预览打开了！') }, // 预览窗口打开时的callback
            beforeOpenCallback() { console.log('开始打印之前！') }, // 开始打印之前的callback
            openCallback() { console.log('执行打印了！') }, // 调用打印时的callback
            closeCallback() { console.log('关闭了打印工具！') }, // 关闭打印的callback(无法区分确认or取消)
            clickMounted() { console.log('点击v-print绑定的按钮了！') },
        });
        onMounted(() => {
            getList();
        });

        return {
            ...toRefs(state),
            columns,
            pagination,
            getDetail,
            print,
            filterOption,
            handleTableChange,
            onDel,
            onSearch,
            onReset
        };
    },
});
